//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vux'
import {mapState} from 'vuex'

import {service, nativeApi} from '@/common/index'
import {fetch} from '@/page/index'
import moment from 'moment'
import {Dialog, Toast} from 'vant'
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      value: '',
      headerId: this.$route.query.bidHeaderId,
      quote: {},
      showDatePicker: false,
      showDatePicker2: false,
      minDate: moment().subtract(1, "year").toDate(), //最小可选
      maxDate: moment().add(1, "year").toDate(), //最大可选
      pickIndex: -1,
      pickDate: moment().startOf("day").toDate(), //选中日期
      time: 30000,
      baseUnits: [],
      taxList: [],
      currencyCodeList: [],
      paymentList: [],
      taxColumns: [],
      currencyCodeColumns: [],
      paymentColumns: [],
      taxIndex: 0,
      currencyCodeIndex: 0,
      paymentIndex: 0,
      showTaxPicker: false,
      showTaxCurrencyCode: false,
      showPayment: false,
      respondItemIndex: -1,
      // source 寻源单附件
      activeFujian: [''],
      showSource: false, // popup显示/隐藏
      sourceIds: '', // 文件ids
      sourceFileList: [], // 文件列表 用于展示
      // quote 报价附件
      showQuotation: false,
      quoteIds: '',
      quoteFileList: []
    }
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes
    }),
    noTaxPriceTotal: {
      get() {
        let total = 0
        if (this.quote == null || this.quote.respondItemVOList == null) {
          return total
        }
        this.quote.respondItemVOList.forEach((item) => {
          total += item.demandQuantity * item.noTaxPrice
        })
        return total
      },
      set() {
      }
    },
    checkTaxEditAble: {
      get() {
        if (this.quote.taxRateUpdateFlag === 'Y') {
          return true
        }
        return false
      },
      set() {
      }
    },
    // 判断是合同还是一揽子和询价价格 是否显示行
    checkDisplayLine: {
      get() {
        if (this.quote.auctionResult === 'FRA_AGREEMENT' || this.quote.auctionResult === 'INQUIRY_PRICE') {
          return true
        }
        return false
      },
      set() {
      }
    },
    // 判断是询价价格 是否显示行
    checkResult: {
      get() {
        if (this.quote.auctionResult === 'INQUIRY_PRICE') {
          return true
        }
        return false
      },
      set() {
      }
    }
  },
  created() {
    //this.requestBaseUnit()
    this.requestDetail()
    this.requestTaxList()
  },
  activated: function () {
  },
  methods: {
    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    /**格式化数字*/
    getFormatNumberValue(val) {
      return new SrmCommonUtils(this).getFormatNumberValue(val)
    },
    requestDetail() {
      fetch
        .mobileFindById111({
          lan: this.languageCode,
          bidHeaderId: this.headerId,
        })
        .then((res) => {
          if (res.status === 'S') {
            if (res.code === 'S') {
              this.quote = res.data
              if (this.quote.bidEndDate) {
                const end = moment(this.quote.bidEndDate).valueOf()
                const current = moment().valueOf()
                this.time = end - current
              }
              // 列表
              fetch
                .bidItemRestful_listSfdBidItem({
                  lan: this.languageCode,
                  bidHeaderId: this.headerId,
                })
                .then((res) => {
                  if (res.status === 'S') {
                    if (res.code === 'S') {
                      let items = res.data
                      items.forEach((item) => {
                        item.noTaxPrice = ''
                        item.taxPrice = ''
                      })
                      this.quote.items = res.data
                    }
                  }
                })
              // this.initFilds()
            }
          }
        })
    },
    requestTaxList() {
      this.taxList = this.dicCodes.BASE_TAX_LIST
      this.taxColumns = this.taxList
        .sort((a, b) => a.meaning - b.meaning)
        .map((item) => {
          item.text = item.meaning
          return item
        })
      this.currencyCodeList = this.dicCodes.BASE_CURRENCY_TYPE
      this.currencyCodeColumns = this.currencyCodeList
        .sort((a, b) => a.meaning - b.meaning)
        .map((item) => {
          item.text = item.meaning
          return item
        })
      // 查询付款条件
      // pay_list_listByPage: `${srmServerUrl}/v1/srmBasePaymentTermRestful/listByPage`, // 付款条件表分页查询列表
      fetch
        .pay_list_listByPage({
          lan: this.languageCode,
          pageIndex: 1, //页数
          pageRows: 999
        })
        .then((res) => {
          if (res.status === "S") {
            if (res.code === "S") {
              //清楚最后多余的数据
              this.paymentList = res.data
              this.paymentColumns = this.paymentList
                .sort((a, b) => a.paymentTermName - b.paymentTermName)
                .map((item) => {
                  item.text = item.paymentTermName
                  return item
                })
            }
          }
        });

    },
    countFinish() {
      console.log('finish')
      // todo: 结束后效果
    },
    inputNoTaxPrice(item) {
      item.noTaxPrice = this.checkFloat(item.noTaxPrice)
      // 更新含税单价
      this.updateWithTaxPrice(item)
    },
    inputTaxPrice(item) {
      item.taxPrice = this.checkFloat(item.taxPrice)
      // 更新不含税单价
      this.updateWithNoTaxPrice(item)
    },
    inputLadderNoTaxPrice(item) {
      item.ladderNoTaxPrice = this.checkFloat(item.ladderNoTaxPrice)
      // 更新含税单价 ladderNoTaxPrice ladderTaxPrice
      this.updateWithLadderTaxPrice(item)
      item.noTaxPrice = ''
      item.taxPrice = ''
    },
    inputLadderTaxPrice(item) {
      item.ladderTaxPrice = this.checkFloat(item.ladderTaxPrice)
      // 更新含税单价 ladderNoTaxPrice ladderTaxPrice
      this.updateWithLadderNoTaxPrice(item)
    },
    // 取小数点后两位
    checkFloat(price) {
      let rel = price
      const point = String(price).indexOf('.') // 小数点
      if (point != -1) {
        rel = price.slice(0, point + 5)
      }
      return rel
    },
    //biddingRuleVO.allowModifyTaxFlag
    // 更新不含税单价 含税未税金额
    updateWithNoTaxPrice(item) {
      const tax = item.taxPrice // 含税单价
      const taxRate = item.taxRate // 税率快码值
      // const tax = this.getLookupValuesMeaning('BASE_TAX_LIST', taxCode)
      const noTax = tax / (1 + taxRate / 100) // 不含税单价

      item.noTaxPrice = noTax.toFixed(4)

      item.noTaxAmount = (noTax * item.demandQuantity).toFixed(4)
      item.taxAmount = (tax * item.demandQuantity).toFixed(4)
    },

    // 更新含税单价 含税未税金额
    updateWithTaxPrice(item) {
      const noTax = item.noTaxPrice // 不含税单价
      const taxRate = item.taxRate // 税率快码值
      // const tax = this.getLookupValuesMeaning('BASE_TAX_LIST', taxCode)
      const withTax = noTax * (1 + taxRate / 100)

      item.taxPrice = withTax.toFixed(4)

      item.noTaxAmount = (noTax * item.demandQuantity).toFixed(4)
      item.taxAmount = (withTax * item.demandQuantity).toFixed(4)
    },
    // 更新阶梯含税单价 ladderNoTaxPrice ladderTaxPrice
    updateWithLadderTaxPrice(item) {
      const noTax = item.ladderNoTaxPrice // 不含税单价
      const taxRate = item.taxRate // 税率快码值
      // const tax = this.getLookupValuesMeaning('BASE_TAX_LIST', taxCode)
      const withTax = noTax * (1 + taxRate / 100)
      item.ladderTaxPrice = withTax.toFixed(4)
      item.noTaxPrice = ''
      item.taxPrice = ''
    },
    // 更新阶梯不含税单价 ladderNoTaxPrice ladderTaxPrice
    updateWithLadderNoTaxPrice(item) {
      const tax = item.ladderTaxPrice // 含税单价
      const taxRate = item.taxRate // 税率快码值
      // const tax = this.getLookupValuesMeaning('BASE_TAX_LIST', taxCode)
      const withTax = tax / (1 + taxRate / 100)
      item.ladderNoTaxPrice = withTax.toFixed(4)
      item.noTaxPrice = ''
      item.taxPrice = ''
    },
    // 点击税率cell
    onClickPayment(quote) {
      // 判断可否设置税率
      if (this.quote.paymentConditionUpdateFlag !=='Y') {
        return
      }

      const paymentTermName =this.quote.paymentTermName

      this.paymentColumns = this.paymentList
      this.paymentIndex = this.paymentColumns.findIndex((column) => {
        return column.lookupCode == paymentTermName
      })
      // 显示picker
      this.showPayment = true
    },
    // 点击税率cell
    onClickCurrencyCode(quote) {
      // 判断可否设置税率
      if (this.quote.currencyCodeUpdateFlag !=='Y') {
        return
      }
      const currencyCode =this.quote.currencyCode

      this.currencyCodeColumns = this.currencyCodeList
      this.currencyCodeIndex = this.currencyCodeColumns.findIndex((column) => {
        return column.lookupCode == currencyCode
      })
      // 显示picker
      this.showTaxCurrencyCode = true
    },
    onClickTax(item, index) {
      // 判断可否设置税率
      if (!this.checkTaxEditAble) {
        return
      }
      // 1、设置picker默认index
      const tax = item.taxCode
      this.taxIndex = this.taxColumns.findIndex((column) => {
        return column.lookupCode == tax
      })
      // 记录设置respondItemVOList的index
      this.respondItemIndex = index
      // 显示picker
      this.showTaxPicker = true
    },
    // picker确认选项
    onConfirmPayment(val) {

      this.quote.paymentTermName = val.paymentTermName;
      this.quote.paymentTermId = val.paymentTermId;
      this.showPayment = false
    },
    // picker确认选项
    onConfirmCurrencyCode(val) {

      this.quote.currencyCode = val.description;
      this.showTaxCurrencyCode = false
    },

    // picker确认选项
    onConfirmTax(val) {
      // todo：更新制定的vo
      // taxRate
      const item = this.quote.items[this.respondItemIndex]; //选中物料
      item.taxRate = val.description; //更新税率
      item.taxRateCode = val.lookupCode; //更新税率
      // 更新含税单价
      if (this.checkDisplayLine){
        this.updateWithLadderTaxPrice(item)
      }else {
        this.updateWithTaxPrice(item)
      }
      this.showTaxPicker = false
    },
    save1() {
      this.quote.lan = this.languageCode
      const params = JSON.parse(JSON.stringify(this.quote))
      fetch.moblieSaveOrUpdate(params).then((res) => {
        if (res.status === 'S') {
          if (res.code === 'S') {
            this.requestDetail()
            Toast('报价单保存成功')
          }
        }
      })
    },

    save() {
      let safe = this;
      if (safe.quote.items && safe.quote.items.length > 0) {
        for (let i = 0; i < safe.quote.items.length; i++) {
          if (!!safe.quote.items[i].taxPrice && !!safe.quote.items[i].priceCeiling && safe.quote.items[i].taxPrice > safe.quote.items[i].priceCeiling) {
            Toast('物料：' + safe.quote.items[i].itemName + '，不能超过最高限价');
            return;
          }
        }
      }
      let extIP = this.userInfo.clientIpAddress;
      this.$set(this.quote, "ipAddress", extIP);
      fetch.bidHeaderRestful_saveOrUpdate(this.quote).then(res => {
        if (res.status === "S") {
          Toast('报价单保存成功')
          this.requestDetail()
        } else {
          Toast(res.msg);
        }
      })
    },
    submit() {
      let safe = this;
      if (safe.quote.items && safe.quote.items.length > 0) {
        for (let i = 0; i < safe.quote.items.length; i++) {
          if (!!safe.quote.items[i].taxPrice && !!safe.quote.items[i].priceCeiling && safe.quote.items[i].taxPrice > safe.quote.items[i].priceCeiling) {
            Toast('物料：' + safe.quote.items[i].itemName + '，不能超过最高限价');
            return;
          }
        }
      }
      let extIP = this.userInfo.clientIpAddress;
      this.$set(this.quote, "ipAddress", extIP);
      fetch.bidHeaderRestful_doSubmit(this.quote).then(res => {
        if (res.status === "S") {
          Toast('报价单提交成功')
          this.requestDetail()
        } else {
          Toast(res.msg);
        }
      })
    }, submit1() {
      this.quote.lan = this.languageCode
      const params = JSON.parse(JSON.stringify(this.quote))
      fetch.mobileDoSubmit(params).then((res) => {
        if (res.status === 'S') {
          if (res.code === 'S') {
            this.requestDetail()
            Toast('报价单提交成功')
          }
        }
      })
    },
    checkEditAble() {
      // !(
      //     this.quote.publishCommFlag == "Y" &&
      //     this.quote.respondCommStatus == "DRAFT" &&
      //     this.quote.allowModifyTaxFlag == "Y"
      //   )
      return (
        this.quote.bidStatus === 'DRAFT'
      )

      /* return (
         (this.quote.publishTechFlag == 'Y' &&
           this.quote.respondTechStatus == 'DRAFT') ||
         (this.quote.publishCommFlag == 'Y' &&
           this.quote.respondCommStatus == 'DRAFT')
       )*/
    },
    /**
     * 附件相关 start
     */
    // 获取头部信息后，初始化附件(寻源单、报价)列表
    initFilds() {
      // 寻源单附件
      this.sourceIds = JSON.parse(JSON.stringify(this.quote.sourcingFilds))
      if (this.sourceIds == null || this.sourceIds == '') return
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: this.sourceIds
        })
        .then((res) => {
          if (res.status === 'S' && res.code === 'S') {
            this.sourceFileList = res.data.map((source) => {
              return {
                status: 'done',
                file: {
                  name: source.originalFileName
                },
                path: source.filePath,
                fileId: source.id,
                download: true
              }
            })
          }
        })
      // 报价附件
      this.quoteIds = JSON.parse(JSON.stringify(this.quote.quotationFilds))
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: this.quoteIds
        })
        .then((res) => {
          if (res.status === 'S' && res.code === 'S') {
            this.quoteFileList = res.data.map((quotation) => {
              return {
                status: 'done',
                file: {
                  name: quotation.originalFileName
                },
                path: quotation.filePath,
                fileId: quotation.id,
                download: true
              }
            })
          }
        })
    },
    afterRead(type) {
      let doc // 找到最新添加的文件
      switch (type) {
        case 'source':
          doc = this.sourceFileList.find((item) => {
            return item.status == '' || item.status == null
          })
          break
        case 'quote':
          if (this.quoteFileList == null || this.quoteFileList == '') return
          doc = this.quoteFileList.find((item) => {
            return item.status == '' || item.status == null
          })
          break
        default:
          break
      }
      if (!doc) return
      doc.status = 'uploading' // 上传中。。。
      // 上传文件
      fetch
        .fileUpload({
          files: doc.file
        })
        .then((res) => {
          if (res.status === 'S' && res.code === 'S') {
            // 上传完成
            const fujian = res.data[0]
            doc.status = 'done' // 上传完成
            doc.fileId = fujian.id // 记录后台返回的文件Id
            doc.download = false
            // 更新附件ids参数
            this.uploadIds(type)
          } else {
            // 上传失败，设置状态"上传失败"
            doc.status = 'failed'
          }
        })
    },
    uploadIds(type) {
      switch (type) {
        case 'source':
          if (this.sourceFileList == null || this.sourceFileList.length == 0) {
            return
          }
          this.sourceIds = this.sourceFileList
            .filter((file) => {
              return file.fileId != null && file.fileId != '' // 筛选有id的文件，即已上传成功的文件
            })
            .map((item) => {
              return item.fileId // 取id值
            })
            .toString() // 转字符串
          // 更新到quote
          this.quote.sourcingFilds =
            this.sourceIds == null ? '' : this.sourceIds
          break
        case 'quote':
          if (this.quoteFileList == null || this.quoteFileList.length == 0) {
            return
          }
          this.quoteIds = this.quoteFileList
            .filter((file) => {
              return file.fileId != null && file.fileId != '' // 筛选有id的文件，即已上传成功的文件
            })
            .map((item) => {
              return item.fileId // 取id值
            })
            .toString() // 转字符串
          // 更新到quote
          this.quote.quotationFilds =
            this.quoteIds == null ? '' : this.quoteIds
          break

        default:
          break
      }
    },
    // 下载文件
    download(file) {
      console.log(file)
      fetch
        .getFileUrl({
          id: file.fileId
        })
        .then((res) => {
          if (res.status === 'S' && res.code === 'S') {
            Dialog.confirm({
              title: '附件下载',
              message: '是否确认下载附件?'
            })
              .then(() => {
                window.location.href = res.data
              })
              .catch(() => {
              })
          }
        })
    },
    // 删除文件
    deleteFujian(type, file) {
      Dialog.confirm({
        title: '附件删除',
        message: '是否确认删除附件?'
      })
        .then(() => {
          switch (type) {
            case 'source':
              const srcIndex = this.sourceFileList.findIndex((item) => {
                return (item.fileId = file.fileId)
              })
              this.sourceFileList.splice(srcIndex, 1)
              break
            case 'quote':
              const quoIndex = this.quoteFileList.findIndex((item) => {
                return (item.fileId = file.fileId)
              })
              this.quoteFileList.splice(quoIndex, 1)
              break

            default:
              break
          }
          this.uploadIds(type)
        })
        .catch(() => {
        })
    },
    /**
     * 弃用
     */
    afterDelete(type) {
      this.uploadIds(type)
    },
    clickPreview(file) {
      fetch
        .getFileUrl({
          id: file.id
        })
        .then((res) => {
          if (res.status === 'S' && res.code === 'S') {
            Dialog.confirm({
              title: '附件下载',
              message: '是否确认下载附件?'
            })
              .then(() => {
                window.location.href = res.data
              })
              .catch(() => {
              })
          }
        })
    },
    //点击反馈日期
    onClickFeedbackDate(item, index) {
      if (this.quote.dateUpdateFlag !== 'Y'){
        return;
      }else {
        //设置选中日期
        const date =
          item.promisedStartDate == null
            ? moment().startOf("day").toDate()
            : moment(item.promisedStartDate).toDate();
        this.pickDate = date;
        this.pickIndex = index; //记录物料index
        this.showDatePicker = true;
      }

    },
    //确认反馈日期
    onConfirmDate(date) {
      const deliverDate = moment(date).format("YYYY-MM-DD");
      const item = this.quote.items[this.pickIndex]; //选中物料
      item.promisedStartDate = deliverDate; //更新日期
      //重置选择器
      this.pickIndex = -1;
      this.showDatePicker = false;
    },
    //点击承诺有效期至
    onClickPromisedEndDate(item, index) {
      if (this.quote.dateUpdateFlag !== 'Y'){
        return;
      }else {

        //设置选中日期
        const date =
          item.promisedEndDate == null
            ? moment().startOf("day").toDate()
            : moment(item.promisedEndDate).toDate();
        this.pickDate = date;
        this.pickIndex = index; //记录物料index
        this.showDatePicker2 = true;
      }
    },
    //确认反馈日期
    onConfirmDateEnd(date) {
      const deliverDate = moment(date).format("YYYY-MM-DD");
      const item = this.quote.items[this.pickIndex]; //选中物料
      item.promisedEndDate = deliverDate; //更新日期
      //重置选择器
      this.pickIndex = -1;
      this.showDatePicker2 = false;
    },


    //格式化月份
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    submitfujian(type) {
      switch (type) {
        case 'source':
          this.quote.sourcingFilds =
            this.sourceIds == null ? '' : this.sourceIds
          this.showSource = false
          break
        case 'quote':
          this.quote.quotationFilds =
            this.quoteIds == null ? '' : this.quoteIds
          this.showQuotation = false
          break

        default:
          break
      }
    },
    onClickfujian(type) {
      let ids = ''
      switch (type) {
        case 'source':
          this.sourceIds = JSON.parse(JSON.stringify(this.quote.sourcingFilds))
          ids = this.sourceIds
          this.showSource = true
          break
        case 'quote':
          this.quoteIds = JSON.parse(JSON.stringify(this.quote.quotationFilds))
          ids = this.quoteIds
          this.showQuotation = true
          break
      }
      if (ids == null || ids == '') {
        return
      }
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: ids
        })
        .then((res) => {
          if (res.status === 'S' && res.code === 'S') {
            const fileList = res.data.map((source) => {
              return {
                status: 'done',
                file: {
                  name: source.originalFileName
                },
                path: source.filePath,
                fileId: source.id,
                download: true
              }
            })
            switch (type) {
              case 'source':
                this.sourceFileList = fileList
                break
              case 'quote':
                this.quoteFileList = fileList
                break
            }
          }
        })
    }

    /**
     * 附件相关 start
     */
  },
  filters: {
    fileNum(ids) {
      if (ids == null || ids.length == 0) return '无'
      const list = ids.split(',')
      return list.length + '个'
    }
  },
  watch: {},
  mounted() {
  }
}



// WEBPACK FOOTER //
// ./src/page/srm/quote/quote.vue